document.addEventListener('DOMContentLoaded', () => {
    // Wait for all scripts to load
    setTimeout(() => {
        // Reference to upsell popup
        const upsellPopup = document.getElementById('UpsellPopup');
        if (!upsellPopup) {
            return;
        }

        // Read the whitelist of product handles from theme settings (set via Liquid data attribute)
        const etPopup = document.getElementById('EtUpsellPopup');
        let UPSELL_ALLOWED_HANDLES = [];
        try {
            const handlesAttr = etPopup ? etPopup.getAttribute('data-upsell-handles') : null;
            if (handlesAttr) {
                UPSELL_ALLOWED_HANDLES = JSON.parse(handlesAttr).map(h => h.toLowerCase());
            }
        } catch (e) {
            // Silent error handling
        }

        // Helper: check if a handle matches any whitelisted handle
        // Uses partial matching so e.g. "bucketdeal-v3" matches "bucketdeal"
        function isUpsellAllowed(handle) {
            if (!handle || UPSELL_ALLOWED_HANDLES.length === 0) return false;
            const h = handle.toLowerCase();
            return UPSELL_ALLOWED_HANDLES.some(allowed => h.includes(allowed) || allowed.includes(h));
        }

        // Helper: extract product handle from a URL path like /products/ceramic-seal
        function getHandleFromUrl(url) {
            try {
                const path = new URL(url, window.location.origin).pathname;
                const match = path.match(/\/products\/([^/?#]+)/);
                return match ? match[1] : null;
            } catch (e) {
                return null;
            }
        }

        // Helper function to check if test is active
        const isTestActive = () => {
            // const hasClass = document.body.classList.contains('pdp_021');
            // const hasIgParam = window.location.search.includes('ig_'); // Intelligems preview
            // // If the body has the class or we are in an Intelligems preview mode, activate the test
            // return hasClass || hasIgParam;
            return false;
        };

        // Helper function to toggle test mode (can be called from console: window.toggleUpsellTest())
        // window.toggleUpsellTest = function (forceState) {
        //     if (typeof forceState === 'boolean') {
        //         if (forceState) {
        //             document.body.classList.add('pdp_021');
        //         } else {
        //             document.body.classList.remove('pdp_021');
        //         }
        //     } else {
        //         document.body.classList.toggle('pdp_021');
        //     }
        //     return isTestActive() ? 'Test mode is now ACTIVE' : 'Test mode is now INACTIVE';
        // };

        // Function to show upsell popup with product name and ID
        function showUpsellPopup(productName = '', productId = '', productImage = '', productHandle = '') {
            // Ensure we have a valid product ID
            const validProductId = String(productId).trim();

            // Force close cart drawer if it's open
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
                // If it has active class, remove it
                if (cartDrawer.classList.contains('active') || cartDrawer.classList.contains('animate')) {
                    cartDrawer.classList.remove('active', 'animate');
                    document.body.classList.remove('overflow-hidden');
                }
            }

            // Use the new ET upsell popup if available
            if (window.showEtUpsellPopup) {
                window.showEtUpsellPopup(productName, validProductId, productImage, productHandle);
            } else if (window.showUpsellPopupWithRecommendations) {
                window.showUpsellPopupWithRecommendations(productName, validProductId);
            } else {
                // Fallback to the old method if new function not available
                if (productName) {
                    const productNameElement = document.getElementById('upsell-product-name');
                    if (productNameElement) {
                        productNameElement.textContent = `${productName}`;
                        productNameElement.style.display = 'block';
                    }
                }

                // Show the popup
                if (upsellPopup) {
                    upsellPopup.style.display = 'flex';
                    document.body.classList.add('overflow-hidden');
                }
            }
        }

        // Store the original open method at a higher scope level
        let originalCartOpen = null;
        let lastAddedProduct = null;

        // Intercept cart drawer open method
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
            // Store a reference to the original method for later
            originalCartOpen = cartDrawer.open;
            cartDrawer._originalOpen = originalCartOpen;

            // Override the open method
            cartDrawer.open = function () {
                // Suppress cart drawer when an upsell card product was just added
                if (window._etUpsellCartAdd) {
                    return false;
                }
                if (isTestActive() && lastAddedProduct) {
                    // Check if the product is in the whitelist
                    const handle = lastAddedProduct.handle || getHandleFromUrl(window.location.href);
                    if (isUpsellAllowed(handle)) {
                        // Show upsell popup instead of cart drawer
                        showUpsellPopup(lastAddedProduct.title, lastAddedProduct.product_id, lastAddedProduct.image || lastAddedProduct.featured_image || '', lastAddedProduct.handle || getHandleFromUrl(window.location.href) || '');
                        lastAddedProduct = null; // Reset after showing
                        return false; // Prevent original method from running
                    }
                }
                // Call original open method (for non-whitelisted products or no product)
                originalCartOpen.apply(this, arguments);
            };

            // Additional interception to prevent cart drawer from opening
            const observer = new MutationObserver((mutations) => {
                if (isTestActive()) {
                    mutations.forEach((mutation) => {
                        if (mutation.type === 'attributes' &&
                            mutation.attributeName === 'class' &&
                            cartDrawer.classList.contains('active') &&
                            upsellPopup.style.display === 'flex') {

                            // Remove the active class to close the cart drawer
                            setTimeout(() => {
                                cartDrawer.classList.remove('active', 'animate');
                            }, 0);
                        }
                    });
                }
            });

            // Start observing the cart drawer
            observer.observe(cartDrawer, { attributes: true });
        }

        // Listen for cart updates to detect when products are added
        document.addEventListener('cart:updated', function (event) {
            if (isTestActive()) {
                const cartData = event.detail && event.detail.cart;
                if (cartData && cartData.items && cartData.items.length > 0) {
                    // Get the most recently added item
                    lastAddedProduct = cartData.items[0];
                }
            }
        });

        // Listen for ajax:success events to detect cart add completion
        document.addEventListener('ajax:success', function (event) {
            if (!isTestActive()) return;
            try {
                const detail = event.detail;

                // Check if this is a cart/add response
                if (detail && detail[0] && detail[2] && detail[2].url && detail[2].url.includes('/cart/add')) {
                    const data = detail[0];
                    if (data && data.items && data.items.length > 0) {
                        const addedItem = data.items[0];
                        const handle = addedItem.handle || getHandleFromUrl(window.location.href);

                        if (isUpsellAllowed(handle)) {
                            // Show upsell instead of cart
                            showUpsellPopup(addedItem.product_title, addedItem.product_id, addedItem.image || addedItem.featured_image || '', addedItem.handle || getHandleFromUrl(window.location.href) || '');

                            // Prevent normal cart from opening
                            event.stopPropagation();
                        }

                        // Update last added product for future reference
                        lastAddedProduct = addedItem;
                    }
                }
            } catch (error) {
                // Silent error handling
            }
        });

        // Handle direct fetch to cart/add.js (for themes that use fetch API)
        const originalFetch = window.fetch;
        window.fetch = function (url, options) {
            // Call the original fetch
            const fetchPromise = originalFetch.apply(this, arguments);

            // Only intercept cart/add calls
            if (isTestActive() && url && typeof url === 'string' && url.includes('/cart/add')) {
                // Try to extract product ID from the request if possible
                let requestProductId = null;
                if (options && options.body) {
                    try {
                        // Extract from FormData if possible
                        if (options.body instanceof FormData) {
                            const formData = options.body;
                            requestProductId = formData.get('id') || formData.get('items[0][id]');
                        }
                        // Extract from JSON body if possible
                        else if (typeof options.body === 'string' && options.body.includes('id')) {
                            const bodyData = JSON.parse(options.body);
                            if (bodyData.id) {
                                requestProductId = bodyData.id;
                            } else if (bodyData.items && bodyData.items.length > 0) {
                                requestProductId = bodyData.items[0].id;
                            }
                        }
                    } catch (e) {
                        // Silent error handling
                    }
                }

                // Process the response to show upsell popup
            fetchPromise.then(async response => {
    try {
        if (!url.includes('/cart/add')) return;
        const clonedResponse = response.clone();
        const data = await clonedResponse.json();

                        if (data && data.items && data.items.length > 0) {
                            const addedItem = data.items[0];

                            // Ensure we have a product ID (either from response or request)
                            const productId = addedItem.product_id || requestProductId;

                            // Check if the added product is in the whitelist
                            const handle = addedItem.handle || getHandleFromUrl(window.location.href);

                            // Update last added product
                            lastAddedProduct = addedItem;

                            if (isUpsellAllowed(handle)) {
                                // Immediately prevent cart drawer from opening by clearing its classes
                                if (cartDrawer) {
                                    if (cartDrawer.classList.contains('active') || cartDrawer.classList.contains('animate')) {
                                        cartDrawer.classList.remove('active', 'animate');
                                    }

                                    // Override any event listeners that might open the cart
                                    document.querySelectorAll('.cart-count-bubble, [aria-controls="cart-drawer"]').forEach(el => {
                                        const clone = el.cloneNode(true);
                                        if (el.parentNode) {
                                            el.parentNode.replaceChild(clone, el);
                                        }
                                    });
                                }

                                // Show upsell popup after a small delay to let any cart drawer animations complete
                                setTimeout(() => {
                                    showUpsellPopup(addedItem.product_title, productId, addedItem.image || addedItem.featured_image || '', addedItem.handle || getHandleFromUrl(window.location.href) || '');
                                }, 100);
                            }
                        }
                    } catch (error) {
                        // Silent error handling
                    }
                });
            }

            // Return the original fetch promise
            return fetchPromise;
        };

        // Make sure clicking "add to cart" buttons triggers the upsell popup
        document.addEventListener('click', function (event) {
            if (!isTestActive()) return;

            // Find the button that was clicked (or its parent if a child element was clicked)
            let button = event.target.closest('[type="submit"][name="add"]');
            if (!button) {
                button = event.target.closest('.product-form__submit');
            }

            if (button) {
                // Find the form that contains the button
                const form = button.closest('form[action*="/cart/add"]');
                if (form) {
                    const formData = new FormData(form);
                    const productId = formData.get('id');
                    if (productId) {
                        const productTitleElement = document.querySelector('.product__title h1');
                        const productTitle = productTitleElement ? productTitleElement.textContent.trim() : '';

                        // Try to find the product image on the page
                        const productImageEl = document.querySelector('.product__media img, .product-media-container img');
                        const productImageSrc = productImageEl ? productImageEl.src : '';

                        // Update the last added product with info from the form
                        lastAddedProduct = {
                            product_id: productId,
                            product_title: productTitle,
                            title: productTitle,
                            image: productImageSrc
                        };
                    }
                }
            }
        });
    }, 0);
});